import parser from "html-react-parser";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

import styles from "./ScoreContainer.module.scss";

export default function ScoreContainer({ scores }) {
  const router = useRouter();

  function handleAnimatedCounter() {
    const counters = document.querySelectorAll(".counter");
    const speed = 200;

    counters.forEach((counter: HTMLElement, i) => {
      const updateCount = () => {
        const target = +counter.getAttribute("data-target");
        const count = +counter.innerText;
        const inc = target / speed;

        if (count < target) {
          if (i === 0) {
            counter.innerText = `${(count + inc).toFixed(2)}`;
            setTimeout(updateCount, 1);
          } else {
            counter.innerText = `${(count + inc).toFixed(2)}`;
            setTimeout(updateCount, 1);
          }
        } else {
          counter.innerText = `${target}`;
        }
      };
      updateCount();
    });
  }

  if (typeof window !== undefined) {
    gsap.registerPlugin(ScrollTrigger);
  }

  useEffect(() => {
    if (ScrollTrigger.getById("services-score")) {
      ScrollTrigger.getById("services-score").kill();
    }

    setTimeout(() => {
      if (process.browser) {
        gsap.to("#score-container", {
          scrollTrigger: {
            id: "services-score",
            trigger: "#score-container",
            start: "top bottom",
            onEnter: () => handleAnimatedCounter(),
          },
        });
      }
    }, 200);
  }, [router.asPath]);

  return (
    <div
      id="score-container"
      className={`container ${styles._scores_container}`}
    >
      {scores.map((score, i) => {
        return (
          <div key={"score" + i} className={styles._score_card}>
            <p className={`${styles._score_value}`}>
              <strong className="counter" data-target={score.value.number}>
                0
              </strong>
              <br />
              {score.value.text}
            </p>
            <p className={styles._score_description}>
              {parser(score.text)}
              {score.mention && <span>{parser(score.mention)}</span>}
            </p>
          </div>
        );
      })}
    </div>
  );
}
